"use strict";
/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */

Object.defineProperty(exports, "__esModule", {
  value: true
}); //
// Fragments.
//

exports.CHAR = "\t\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
exports.S = " \t\r\n"; // tslint:disable-next-line:max-line-length

exports.NAME_START_CHAR = ":A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
exports.NAME_CHAR = "-" + exports.NAME_START_CHAR + ".0-9\xB7\u0300-\u036F\u203F-\u2040"; //
// Regular expressions.
//

exports.CHAR_RE = new RegExp("^[" + exports.CHAR + "]$", "u");
exports.S_RE = new RegExp("^[" + exports.S + "]+$", "u");
exports.NAME_START_CHAR_RE = new RegExp("^[" + exports.NAME_START_CHAR + "]$", "u");
exports.NAME_CHAR_RE = new RegExp("^[" + exports.NAME_CHAR + "]$", "u");
exports.NAME_RE = new RegExp("^[" + exports.NAME_START_CHAR + "][" + exports.NAME_CHAR + "]*$", "u");
exports.NMTOKEN_RE = new RegExp("^[" + exports.NAME_CHAR + "]+$", "u");
var TAB = 9;
var NL = 0xA;
var CR = 0xD;
var SPACE = 0x20; //
// Lists.
//

/** All characters in the ``S`` production. */

exports.S_LIST = [SPACE, NL, CR, TAB];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */

function isChar(c) {
  return c >= SPACE && c <= 0xD7FF || c === NL || c === CR || c === TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}

exports.isChar = isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */

function isS(c) {
  return c === SPACE || c === NL || c === CR || c === TAB;
}

exports.isS = isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */

function isNameStartChar(c) {
  return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}

exports.isNameStartChar = isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */

function isNameChar(c) {
  return isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}

exports.isNameChar = isNameChar;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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